// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 1C5.92487 1 1 5.92487 1 12C1 14.6615 1.94632 17.1038 3.51936 19.006L1.30049 23H12C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM8.33269 13.5996C8.95085 15.0144 10.3616 16 12.0003 16C13.639 16 15.0497 15.0144 15.6679 13.5996L16.0683 12.6832L17.901 13.484L17.5006 14.4003C16.5756 16.5173 14.4622 18 12.0003 18C9.53835 18 7.42493 16.5173 6.49998 14.4003L6.09961 13.484L7.93231 12.6832L8.33269 13.5996Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chat-bubble-smile-filled')
export default class ChatBubbleSmileFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chat-bubble-smile-filled',
    }
  }
}
